import { formatString } from './formatString';

export const formatStringArray = (
    array: Array<string | null | undefined> | null | undefined = [],
    separator: string = ', ',
): string => {
    return formatString(array?.filter((item) => item).join(separator));
};
